import {CommonMessages} from '../common.messages';

export const PanelSettingsOperatorsMessages = {
    GetRolesFailed: {
        key: 'GetRolesFailed',
        message: 'Error while communication with the server. Unable to get information about operator roles.'
    },
    GetOperatorsFailed: {
        key: 'GetOperatorsFailed',
        message: 'Error while communication with the server. Unable to get list with operators.'
    },
    ...CommonMessages
};
